<template>
  <div class="p-menu-plan-life">
    <!-- プランのディスカウント表記 -->
    <ul class="p-menu-plan-life__items" v-if="innerWidth > 744">
      <li
        v-for="(course, index) in planBenefit"
        :key="index"
        class="p-menu-plan-life__item"
      >
        <div>
          {{ course.benefitHeading
          }}<span
            v-if="course.benefitContent"
            class="p-menu-plan-life__prices p-menu-plan-life__prices--discount-price"
            >{{ course.benefitContent }}</span
          >
        </div>
        <!-- <div>{{ course.benefitHeading }}</div>
        <div class="p-menu-plan-life__prices">
          <span>{{ course.benefitPrice }}</span>
          <template v-if="course.benefitContent">
            <span class="p-menu-plan-life__prices--discount-price">
              {{ course.benefitContent }}
            </span>
          </template>
        </div> -->
      </li>
    </ul>
    <!-- <div v-if="plan.perfomaceDay" class="p-menu-plan-life__expires">
      お申込み期間：{{ plan.perfomaceDay }}まで
    </div> -->

    <!-- お申し込み期間 -->
    <div
      v-if="plan.planBasicInfo.planRcEndDt"
      class="p-menu-plan-life__expires sm_expire"
    >
      お申込み期間：{{
        $moment(plan.planBasicInfo.planRcEndDt).format("YYYY年MM月DD日")
      }}まで
    </div>

    <!-- 詳細を見るボタン -->
    <div class="p-menu-plan-life__buttons">
      <div class="c-buttons">
        <div class="c-buttons__inner">
          <div
            class="c-buttonWrap5--displayPc"
            @click="
            viewDetail
            "
          >
            <Button :style-type="'secondary'" :color="'color2'">
              詳細を見る
            </Button>
          </div>
        </div>

        <!-- 非表示 2022/03/01 -->
        <!-- <div class="c-buttons__inner" v-if="usageDiv != 55">
            <div
              class="c-buttonWrap5"
              @click="
                $router.push(
                  `/menus/catExl=${queryCode.catExl}/catLrg=${queryCode.catLrg}/catMid=${queryCode.catMid}/catSml=${queryCode.catSml}/menuNo=${queryCode.menuNo}/plans/planId=${plan.planBasicInfo.planId}#application-detail`
                )
              "
            >
              <Button style-type="secondary" color="color1">
                申し込む
              </Button>
            </div>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import func_utils from "@/mixins/func_utils";
import Button from"@/components/Button.vue";
export default {
  mixins: [func_utils],
  props: {
    menuNo: {
      required: true
    },
    plan: {
      type: Object,
      default: () => ({})
    },
    usageDiv: {
      default: 0
    }
  },
  components:{
    Button,
  },
  data() {
    return {
      innerWidth: window.innerWidth
    };
  },
  computed: {
    planBenefit() {
      if (!this.plan || !this.plan.memberBenefits) return {};
      return Array.isArray(this.plan.memberBenefits)
        ? this.plan.memberBenefits.slice().reverse()
        : [this.plan.memberBenefits];
    },
    planId(){
      return this.plan.planBasicInfo.planId
    },
    queryCode() {
      return {
        category: this.$route.params.category
          ? this.$route.params.category.replace("category=", "")
          : "",
        rooms: this.$route.params.rooms
          ? this.$route.params.rooms.replace("rooms=", 1)
          : "",
        roomCnt: this.$route.params.roomCnt
          ? this.$route.params.roomCnt.replace("roomCnt=", 1)
          : "",
        numPeople: this.$route.params.numPeople
          ? this.$route.params.numPeople.replace("numPeople=", 2)
          : "",
        menuNo: this.$route.params.menuNo
          ? this.$route.params.menuNo.replace("menuNo=", "")
          : "",
        stayNights: this.$route.params.stayNights
          ? this.$route.params.stayNights.replace("stayNights=", 1)
          : "",
        adultHeadCnt: this.$route.params.adultHeadCnt
          ? this.$route.params.adultHeadCnt.replace("adultHeadCnt=", 2)
          : "",
        feeUpper: this.$route.params.feeUpper
          ? this.$route.params.feeUpper.replace("feeUpper=", 20000)
          : ""
      };
    }
  },
  methods: {
    viewDetail(){
      const {menuNo} = this.queryCode
      const href = `${process.env.VUE_APP_BASE_URL}/dp/menus/${menuNo}/plans/${this.planId}`
      this.setCurrentHref(href);
      location.href = href
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.c-buttonWrap5--displayPc{
  @include mq() {
    display: none;
  }
}

@media screen and (max-width: $contentWidthS) {
  .sm {
    &_expire {
      text-align: left;
      margin-bottom: 0;
      font-size: 12px;
      color: #1f2021;
    }
  }
}


@import './style.scss';
</style>
